import { render } from "./CreateGhat.vue?vue&type=template&id=56db3352&scoped=true"
import script from "./CreateGhat.vue?vue&type=script&lang=js"
export * from "./CreateGhat.vue?vue&type=script&lang=js"

import "./CreateGhat.vue?vue&type=style&index=0&id=56db3352&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56db3352"]])

export default __exports__